export default __webpack_public_path__ + "static/media/allgemein_17.cbe00277.jpg";